import React, { useEffect, useState } from "react";
import InputField from "@components/inputField";
import ChevronDown from "@public/images/icons/chevron-down.svg";
import {
  capitalizeFirstLetter,
  getErrorMessageForId,
  updateStateBasedOnFieldChange,
} from "@utils/index";
import { ErrorMessage } from "@widgets/qnaHeading/styles";
import { connect } from "react-redux";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

interface InputState {
  [key: string]: any;
}

interface MmvInputFieldProps {
  inputState: InputState;
  value?: string;
  handleInputClick: (id: string) => void;
  mmvId: string;
  [key: string]: any;
  errorMessage?: string;
  cueText?: string;
}

const getValueByKey = (obj: InputState, key: string) => {
  if (!obj) return;
  if (obj.hasOwnProperty(key)) {
    return obj[key];
  } else {
    console.error(`Key "${key}" does not exist in the object.`);
    return null;
  }
};

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    errorMessage: getErrorMessageForId(
      state.configuration.normalisedConfig,
      ownProps.id
    ),
    globalPayloadData: state.globalState?.payloadData
  };
};

const Note = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #5b5675;
  margin-top: ${(props) => props.mt};
  @media (max-width: 768px) {
    width: 342px;
  }
`;

const MmvInputField: React.FC<MmvInputFieldProps> = ({
  inputState, // state object containing input values
  value,
  handleInputClick,
  id,
  errorMessage,
  mmvId,
  cueText,
  ...props
}) => {
  const [inputValue, setInputValue] = useState<any>();
  const [error, setError] = useState<any>(errorMessage);

  useEffect(() => {
    if (errorMessage) {
      setError(errorMessage);
    }
  }, [errorMessage]);

  useEffect(() => {
    // getting value from inputState using the provided id ("make, "model" .. etc)
    const inputValueFromProps = getValueByKey(inputState, mmvId);

    const formattedStringInputValue =
      typeof inputValueFromProps === "string"
        ? capitalizeFirstLetter(inputValueFromProps)
        : inputValueFromProps;

    setInputValue(formattedStringInputValue || value);
    if (formattedStringInputValue || value) {
      // clearign error
      setError("");
    }
  }, [inputState, mmvId, value]);

  const inputHandleClick = () => {
    updateStateBasedOnFieldChange(id);
    handleInputClick(mmvId);
    setError("");
  };

  // padding: 13px 3rem 13px 1rem
  // dweb 120, 98
  // height 48px
  return (
    <div>
      <InputField
        touched={undefined}
        errors={undefined}
        placeholder={""}
        name={""}
        isDesktop={""}
        readOnly={true} // setting input field as read-only
        handleClick={inputHandleClick}
        Icon={ChevronDown}
        value={inputValue}
        inputContainerStyles={"width: 100%; margin-top: 0; "}
        inputStyles={{
          padding: "12px 16px",
          height: "48px",
          "box-sizing": "border-box",
          border: `1px solid ${error ? "#D83D37" : "#E7E7F0"}`
        }}
        {...props}
      />
      {error ? <ErrorMessage>{error}</ErrorMessage> : null}
      {!error && cueText && <Note mt="4px">{cueText}</Note>}
    </div>
  );
};

export default connect(mapStateToProps)(MmvInputField);
